import React, {useState, useRef, useCallback, useEffect, createContext} from 'react';
import {postApi} from './functions';

export const UserContext = createContext();

function useStateCallback(initialState) {
  const [state, setState] = useState(initialState);
  const cbRef = useRef(null); // init mutable ref container for callbacks

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb; // store current, passed callback in ref
    setState(state);
  }, []); // keep object reference stable, exactly like `useState`

  useEffect(() => {
    // cb.current is `null` on initial render, 
    // so we only invoke callback on state *updates*
    if (cbRef.current) {
      cbRef.current(state);
      cbRef.current = null; // reset callback after execution
    }
  }, [state]);

  return [state, setStateCallback];
}

export const UserProvider = (props) => {
	const [user, setUser] = useState({});
	const [worker, setWorkers] = useStateCallback({});
	const [themes, setThemes] = useState(null);
	//const [colours, setColours] = useState(null);

	const setWorker = async (_worker) => {
		if( !_worker ) return;
		return new Promise(async(resolve, reject) => {
			_worker = parseInt(_worker);
			if( !worker[_worker] ) {
				let params = new URLSearchParams();
				params.append('service', _worker);
				params.append('code', '1');
				const x = await postApi('/v3/portal/service', params);
				let workers = {...worker};
				workers[_worker] = x.data;
				setWorkers(workers, ()=>resolve(workers));
				return;
			}
			resolve(true);
		});
	};

	const setTheme = (_themes) => {
		if( !_themes && !_themes.themes ) return;
		if( JSON.stringify(themes) === JSON.stringify(_themes.themes) ) return;
		setThemes(_themes.themes);

		//---- Theme mode light / dark
		if( _themes?.themes?.theme_mode ) {
			let element = document.documentElement;
			let attribute = element.getAttribute("data-theme-mode");
			element.setAttribute("data-theme-mode", _themes.themes.theme_mode);
		}
	};
	
	return (
		<UserContext.Provider value={{user, worker, themes, setUser, setWorker, setTheme}}>
			{/*<link rel="stylesheet" id="_themes" type="text/css" href={`${themes}`} />*/}
			{props.children}
		</UserContext.Provider>
	);
}

export const TestService = (props) => {
	let test = /cloud1/.test(props.worker);
	return (
		<>
			{(parseInt(props.service) !== 1000 && test === true) &&
				<div className="card-footer p-0 text-center">
					<div className="alert alert-solid-success">
						Service running in Test Mode, any changes may not effect the live system!
					</div>
				</div>
			}
		</>
	);
}